/**
 * Function to get cursor position
 */
var ip = require('ip');

export function getRange(el) {
  var cuRange, tbRange, headRange, range, dupRange, ret = {};
  if (el.setSelectionRange) {
    // standard
    ret.begin = el.selectionStart;
    ret.end = el.selectionEnd;
    ret.result = el.value.substring(ret.begin, ret.end);
  } else if (document.selection) {
    // ie
    if (el.tagName.toLowerCase() === 'input') {
      cuRange = document.selection.createRange();
      tbRange = el.createTextRange();
      tbRange.collapse(true);
      tbRange.select();
      headRange = document.selection.createRange();
      headRange.setEndPoint('EndToEnd', cuRange);
      ret.begin = headRange.text.length - cuRange.text.length;
      ret.end = headRange.text.length;
      ret.result = cuRange.text;
      cuRange.select();
    } else if (el.tagName.toLowerCase() === 'textarea') {
      range = document.selection.createRange();
      dupRange = range.duplicate();
      dupRange.moveToElementText(el);
      dupRange.setEndPoint('EndToEnd', range);
      ret.begin = dupRange.text.length - range.text.length;
      ret.end = dupRange.text.length;
      ret.result = range.text;
    }
  }
  el.focus();
  return ret;
}

export function isValidIPItemValue(val) {
  val = parseInt(val);
  return !isNaN(val) && val >= 0 && val <= 255;
}

export function calcCount(ipRange) {
    if (!ipRange) {
        return null;
    }
    const ss = ipRange.split('-');
    if (ss.length > 1) {
        const from = ss[0];
        const fa = from.split('.');
        const to = `${fa[0]}.${fa[1]}.${fa[2]}.${ss[1]}`;
        return (ip.toLong(to) - ip.toLong(from)) + 1;
    } else if (ss.length === 1) {
        return 1;
    } else {
        alert(`Error: calcCount for : ${ipRange}`);
    }
}
function isValid(ipRange) {
    if (!ipRange) {
        return false;
    } else
        return ip.isV4Format(ipRange.split('-')[0]);
}
export function getNotation(ipRange) {
    if (!ipRange) {
        return 'None';
    }
    const ss = ipRange.split('-');
    if (ss.length === 2) {
        return 'From To';
    } else {
        if (ip.isV4Format(ss[0])) {
            return 'Single';
        } else {
            return 'URL';
        }
    }
}
function getFromAndTo(ipRange) {
    const ss = ipRange.split('-');
    if (ss.length === 1) {
        return { from: ipRange, to: ipRange };
    } else if (ss.length === 2) {
        const from = ss[0];
        const fa = from.split('.');
        const to = `${fa[0]}.${fa[1]}.${fa[2]}.${ss[1]}`;
        return { from, to };
    } else {
        throw {};
    }
}
export function isOverlay(left, right) {
    if (!isValid(left) || !isValid(right)) {
        return left === right;
    }
    const l = getFromAndTo(left);
    const r = getFromAndTo(right);
    
    return !(ip.toLong(l.to) < ip.toLong(r.from) || ip.toLong(l.from) > ip.toLong(r.to));
}

function verifySingle(value) {
    if (!ip.isV4Format(value)) {
        return ' IP is not valid';
    }
}
function verifyFromTo(value) {
    const temp = value.split('-');
    const from = temp[0];
    const to = temp[1];
    if (!ip.isV4Format(from)) {
        return { error: '"FROM" IP is not valid' };
    }
    if (!to || to < 1 || to > 255) {
        return { error: '"To" is not valid' };
    }
    const fromInt = parseInt(from.split('.')[3]);
    const toInt = parseInt(to);
    if (fromInt > toInt) {
        return { error: '"From" must be less than "TO"' };
    }
}
function verifyURL() {
    const { url } = this.props;
    if (url) {
        return { value: url };
    } else {
        return { error: 'URL is empty' };
    }
}
export function verify(format, value) {
    if (format === 'From To') {
        return verifyFromTo(value);
    } else if (format === 'Single') {
        return verifySingle(value);
    } else if (format === 'URL') {
        return verifyURL(value);
    } else {
        return 'Not support format :' + format;
    }
}